import React from 'react'
import StandardSkeletonCardLoader from '../organisms/CenterCards/StandardCenterCardSkeletonLoader.jsx'
import { CenterFeedPlacement } from '@/types/models/Center.model.js'
import useDidMount from '@/hooks/useDidMount.jsx'
export const asyncCardLoader = ({
  slug,
  isLoading,
  children
}: {
  slug: CenterFeedPlacement['slug']
  isLoading: boolean
  children?: React.ReactNode
}) => {
  const didMount = useDidMount()

  if (!didMount) {
    return <StandardSkeletonCardLoader />
  }

  return isLoading ? (
    <StandardSkeletonCardLoader />
  ) : (
    <div className={`p-n ${slug}`}>{children}</div>
  )
}

export default asyncCardLoader
